// import AuthService from "./authService";
import HouseService from "./houseService";
import PaymentService from "./paymentService";
import SiteService from "./siteService";
import NavService from "./navService";

const modul = angular
    .module("services", [])

    .factory("navService", NavService)

    // .factory("authService", AuthService)
    .factory("houseService", HouseService)
    .factory("paymentService", PaymentService)
    .factory("siteService", SiteService);

export default modul.name;
